import React from "react";
import Image from "../Image";

import "./styles.css";

export default function Flexbox({ image, setFlexbox }) {
  return (
    <div className="flexbox-container" onClick={() => setFlexbox(false)}>
      <div className="image-container">
        <Image
          src={image}
          alt="chat-image"
          fallbackSrc={
            "https://drogariaguarulhos.com.br/media/catalog/product/placeholder/default/notfound.png"
          }
        />
      </div>
    </div>
  );
}
